<template>
    <div :class="['sub_contents', { 'popup-window-mode': isPopupWindow }]">
        <div class="cont_center">
            <h2 class="title_page">회원 가입</h2>

            <div class="login_box_area">
                <!-- <h3 class="title_login">
                    Hi-Vitamin<br>Membership
                </h3> -->

                <div class="login_input_area">
                    <p class="join_descript">
                        약관 및 정보이용 안내에 동의해 주세요.
                    </p>

                    <div class="term_check_area">
                        <checkBoxTermRef />
                    </div>

                    <div class="btn_login_area">
                        <a href="#" @click.prevent="routerLink()" class="btn_type2">동의하고 가입하기</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import checkBoxTermRef from '@/components/CheckBoxTerm'
import { nextTick, onMounted } from 'vue';
import { useRouter } from "vue-router";
export default {
    components: {
        checkBoxTermRef,
    },
    data() {
        return {
            isPopupWindow: false,
        };
    },
    setup() {
        const router = useRouter();

        onMounted(() => {
            const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
            if ((userData.USER_IN_TYPE || '') === 'USER_IN_KAKAO') {
                router.replace('/HFO_MB_004_SNS');
            }
        });

        function routerLink() {

            const terms = sessionStorage.getItem('termsChecked');
            const privacy = sessionStorage.getItem('privacyChecked');
            const market = sessionStorage.getItem('ecommChecked');
            const userData = JSON.parse(sessionStorage.getItem('userData'));

            console.log('체크', market, privacy, terms, userData.USER_IN_TYPE);

            if (terms === 'true' && privacy === 'true' && market === 'true') {
                if ('USER_IN_NORMAL' === userData.USER_IN_TYPE) {
                    router.push("/HFO_MB_004");
                } else {
                    router.push("/HFO_MB_004_SNS");
                }

            } else {
                alert('필수 약관에 동의해주세요');
            }

        }

        return {
            routerLink
        };




    },
    mounted() {
        try {
            this.isPopupWindow = !!(window.opener && !window.opener.closed);
        } catch (_e) {
            this.isPopupWindow = false;
        }

        this.schedulePopupResize();
        window.addEventListener('resize', this.notifyPopupContentSize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.notifyPopupContentSize);
    },
    methods: {
        notifyPopupContentSize() {
            try {
                const body = document.body;
                const html = document.documentElement;
                const frameWidth = Math.max(0, (window.outerWidth || 0) - (window.innerWidth || 0));
                const frameHeight = Math.max(0, (window.outerHeight || 0) - (window.innerHeight || 0));
                const verticalSafetyGap = 8;

                const contentRoot = document.querySelector('.cont_center')
                    || document.querySelector('.login_box_area')
                    || document.querySelector('.sub_contents');

                let contentWidth = 0;
                let contentHeight = 0;

                if (contentRoot && typeof contentRoot.getBoundingClientRect === 'function') {
                    const rect = contentRoot.getBoundingClientRect();
                    contentWidth = Math.ceil(rect.width);
                    contentHeight = Math.ceil(rect.height);
                } else {
                    contentWidth = Math.max(
                        body?.scrollWidth || 0,
                        body?.offsetWidth || 0,
                        html?.scrollWidth || 0,
                        html?.offsetWidth || 0
                    );
                    contentHeight = Math.max(
                        body?.scrollHeight || 0,
                        body?.offsetHeight || 0,
                        html?.scrollHeight || 0,
                        html?.offsetHeight || 0
                    );
                }

                const screenAvailW = window.screen?.availWidth || window.innerWidth || 560;
                const screenAvailH = window.screen?.availHeight || window.innerHeight || 920;
                const maxWidth = Math.max(420, Math.min(560, screenAvailW - 24));
                const maxHeight = Math.max(520, Math.min(900, screenAvailH - 24));
                const minWidth = Math.min(420, maxWidth);
                const isPopupWindow = !!(window.opener && !window.opener.closed);
                const minHeightBase = isPopupWindow ? 520 : 620;
                const minHeight = Math.min(minHeightBase, maxHeight);

                const requestedWidth = Math.ceil(contentWidth) + frameWidth + 8;
                const requestedHeight = Math.ceil(contentHeight) + frameHeight + verticalSafetyGap;
                const safeWidth = Math.max(minWidth, Math.min(maxWidth, requestedWidth));
                const safeHeight = Math.max(minHeight, Math.min(maxHeight, requestedHeight));
                const payload = { type: 'HVM_POPUP_CONTENT_SIZE', width: safeWidth, height: safeHeight };

                if (window.opener && !window.opener.closed) {
                    window.opener.postMessage(payload, '*');
                } else if (window.parent && window.parent !== window) {
                    window.parent.postMessage(payload, '*');
                }
            } catch (error) {
                console.warn('MB_003 popup size notify failed', error);
            }
        },

        schedulePopupResize() {
            nextTick(() => {
                this.notifyPopupContentSize();
                setTimeout(() => this.notifyPopupContentSize(), 120);
                setTimeout(() => this.notifyPopupContentSize(), 320);
                setTimeout(() => this.notifyPopupContentSize(), 700);
            });
        },
    }
}
</script>

<style scoped>
.sub_contents.popup-window-mode {
    min-height: auto !important;
    height: auto !important;
    max-height: none !important;
    padding-top: 14px !important;
    padding-bottom: 10px !important;
}

.sub_contents.popup-window-mode .cont_center {
    max-width: 560px;
}

.sub_contents.popup-window-mode .login_box_area {
    margin-bottom: 0;
}

.sub_contents.popup-window-mode .btn_login_area {
    margin-top: 16px;
}
</style>